<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">
          Recepciónes de devoluciones a proveedores &nbsp;
          <button class="btn btn-md btn-primary" @click="showModalCreate()">
            <i class="fa fa-pencil"></i>
            <i class="fas fa-plus"></i>
          </button>
        </h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="form-inline justify-content-sm-end">
            <input
              class="form-control form-control-sm rounded bright"
              placeholder="Search"
              v-model="searchtext"
              type="text"
              v-on:keyup.enter="filterData()"
            />
            <select
              class="form-control form-control-sm rounded bright"
              v-model="filterActivo"
              @change="filterData()"
            >
              <option value>Todos</option>
              <option value="9">Anulado</option>
              <option value="A">Abierto</option>
              <option value="C">Finalizado</option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-link btn-sm" type="button" v-on:click="filterData()">
                <i class="fa fa-search"></i>
              </button>
              <button
                class="btn btn-link btn-sm"
                type="button"
                v-on:click="clearFilterData()"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <DevolucionRecepcionModalComponent />
      <DevolucionRecepcionTableComponent :dataTabla="dataTabla" />
      <PaginationComponent
        :currentPage="currentPage"
        :data="dataTabla"
        @pagechanged="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DevolucionRecepcionTableComponent from "@/components/wms/devolucion_recepcion/DevolucionRecepcionTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DevolucionRecepcionModalComponent from "@/components/wms/devolucion_recepcion/DevolucionRecepcionModalComponent";

export default {
  components: {
    DevolucionRecepcionTableComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
    DevolucionRecepcionModalComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: "",
      dataTabla: {},
    };
  },
  mounted() {
    let self = this;
    self.refreshData();
  },
  methods: {
    showModalCreate() {
      let self = this;
      $("#modalCreateNew").modal();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: page,
        "filter[search]": this.searchtext,
        estado: this.filterActivo,
      });
    },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("wms", "recepcion_dev_prov_e", params).then((response) => {
        self.dataTabla = response.data;
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActivo,
      });
    },
    clearFilterData() {
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      this.filterActivo = "";
      this.refreshData();
    },
  },
};
</script>
